import type { BeforeErrorHook } from 'ky';
import { getResponseData } from '../../utils';
import { UAFetchError } from '../../UAFetchError';
import type { ErrorPayload } from '../../../consts/error';
import type { FetchOptions } from '../../types';

async function handleError(args: { response: Response; url: string; options: FetchOptions }) {
  const { response, url, options } = args;
  const responseData = (await getResponseData(response, options)) as Partial<ErrorPayload> | string;

  let messageTitle = 'Failed to fetch',
    errorId = '';
  if (typeof responseData === 'object') {
    messageTitle = responseData.errorMessage || responseData.message || messageTitle;
    errorId = responseData.errorId ?? errorId;
  }

  throw new UAFetchError({
    message: `[UAFetchError] ${messageTitle} ${url} : [${errorId}]`,
    status: response.status,
    statusText: response.statusText,
    url,
    payload: typeof responseData === 'object' ? responseData : { message: responseData },
  });
}

export const getLogBeforeErrorHook = (options: FetchOptions): BeforeErrorHook => {
  return async (error) => {
    const { response, request } = error;
    await handleError({ response, url: request.url, options });
    return error;
  };
};
